export default __webpack_public_path__ + "static/media/Cloudxier-ALBERT-Profile.b9cf2026.png";